import styled from 'styled-components';

import { INPUT_BASE } from '@app/pages/Prototype/Grid/GridItem/Link/TextInput/styles';

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    button {
        max-width: 140px;
    }
`;

export const StyledInput = styled.input`
    display: flex;
    ${INPUT_BASE};
    padding: 20px;
    width: 100%;
    background: ${({ theme }) => theme.shades.white[4]};
    &::placeholder {
        color: ${({ theme }) => theme.shades.white[50]};
    }
`;

export const StyledTextarea = styled.textarea`
    ${INPUT_BASE};
    display: flex;
    resize: none;
    overflow: hidden;
    padding: 4px;
    &::placeholder {
        color: ${({ theme }) => theme.shades.white[50]};
    }
`;

export const StyledSelect = styled.select`
    border-radius: 8px;
    background: none;
    min-width: 200px;
    display: block;
    padding: 4px;
    color: ${({ theme }) => theme.shades.white[50]};
`;
